import React from 'react';
import {
    SimpleForm,
    TextInput,
    DisabledInput,
} from 'react-admin';
import validateForm from './validation';
import { useTranslation } from 'react-i18next';

const AttributeForm = (props) => {
    const { t } = useTranslation();
    const isEdit = props.record && props.record.id;

    return (
        <SimpleForm {...props} redirect={'/attributes'} validate={validateForm}>
            <TextInput
                source={'name'}
                label={t('Name')}
                autoFocus
                fullWidth
            />

            {isEdit ? (
                <DisabledInput
                    source={'slug'}
                    label={t('Slug')}
                    fullWidth
                    helperText={t('URL-friendly identifier (cannot be changed after creation)')}
                />
            ) : (
                <TextInput
                    source={'slug'}
                    label={t('Slug')}
                    fullWidth
                    helperText={t('URL-friendly identifier (lowercase letters, numbers, and hyphens only - cannot be changed after creation)')}
                />
            )}
        </SimpleForm>
    );
};

const TranslatedAttributeForm = (props) => {
    const { t } = useTranslation();
    return <AttributeForm t={t} {...props} />;
};

export default TranslatedAttributeForm;